export default __webpack_public_path__ + "static/media/laundry2-beforeB-768w.30bb6891.avif";